export { MatomoTracker } from './MatomoTracker';
export { getTracker } from './MatomoTrackerStore';
